export default __webpack_public_path__ + "static/media/ER5.c2312012.png";